import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { getDefaultRouteForRole } from '../../authorization';

const DefaultRedirect = ({ role, location, redirectTo, projectName }) => {
  if (!role || !role.length) return null;
  return (
    <Redirect to={redirectTo ? redirectTo : getDefaultRouteForRole(role)} />
  );
};

export default withRouter(DefaultRedirect);
